/* global $ */
import 'core-js/fn/array/find-index';
import { TweenMax } from 'gsap';

import { createElement, PropTypes } from 'rlink-react';
import { Picture } from 'rlink-repos/content-components';
import ArticleBody from 'rlink-blog/ArticleBody';
import { ArticleComponent } from 'rlink-blog/component';
import themeable from 'rlink-theme/themeable';

import ArticleNav from './ArticleNav';
import getArticleLoader from 'helpers/getArticleLoader';

export default class ArticleModal extends ArticleComponent {
  shouldComponentUpdate (nextProps, _nextState) {
    return this.props.article.slug !== nextProps.article.slug;
  }

  componentWillUpdate (_nextProps, _nextState) {
    TweenMax.delayedCall(1, () => {
      $('.ajax-node').show();
      this.loaderObj.hide();
    });
  }

  onArticleNav (callback) {
    this.loaderObj.show(() => {
      $('.ajax-node').hide();
      callback();
    });
  }

  showLoaderCallback () {
    $('.ajax-node').hide();
    TweenMax.delayedCall(0.5, () => {
      let $existingNode = $('.ajax-node');
      if ($existingNode.length) {
        TweenMax.delayedCall(1, () => {
          $existingNode.show();
          this.loaderObj.hide();
        });
        return false;
      } else {
        return $existingNode.length;
      }
    });
  }

  componentDidMount () {
    if (typeof document !== 'undefined') {
      $(window).trigger('scroll-pause');
      $('html').addClass('news');

      this.loaderObj = getArticleLoader();

      // show() returns false if already showing and undefined if not showing
      // In the case where it returns false the callback is not run.
      let didShowTrigger = this.loaderObj.show(() => {
        this.showLoaderCallback();
      });
      if (didShowTrigger === false) {
        this.showLoaderCallback();
      }

    }
  }

  onClose () {
    if ($('html').hasClass('news')) {
      this.loaderObj.show(() => {
        TweenMax.delayedCall(1.0, () => {
          $('.ajax-node').hide();
          this.loaderObj.hide();
          $('html').removeClass('news');
          $(window).trigger('scroll-play');
        });
      });
    }
  }

  render () {
    let { theme, article, articleSummaries } = this.props;
    let articleIndex = articleSummaries.findIndex(possibleArticle =>
      possibleArticle.slug === article.slug
    );
    return (
      <div className="news-content">
        <div className="news-image">
          <div className="field field-name-field-images field-type-image field-label-hidden field-wrapper">
            <Picture
              src={article.bannerImageFormats.src}
              widths={article.bannerImageFormats.widths}
              heights={article.bannerImageFormats.heights}
              formats={article.bannerImageFormats.formats} />
          </div>
        </div>
        <article id="node-8379" className="node node-news node-promoted contextual-links-region view-mode-full large-10 columns medium-centered">

          <div className="content-column">
            <div className="container">
              <h2 className="node-title noline">{article.title}</h2>
              <div className="posted">
                <div className="field field-name-field-submitted-by field-type-text field-label-inline clearfix field-wrapper">
                  <div className="field-label">By&nbsp;</div>
                  <div className="field-items">
                    <div className="field-item even">{article.author.name}</div>
                  </div>
                </div>
                <div className="posted-on">Posted On&nbsp;
                  <span>{this.formatDate(article.publishedOn)}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="body field">
            <ArticleBody
              html={article.body}
              {...ArticleBody.theme({theme})} />
          </div>
          <ArticleNav
            articleSummaries={articleSummaries}
            currentArticleIndex={articleIndex}
            onClose={() => this.onClose()}
            onArticleNav={callback => this.onArticleNav(callback)} />
        </article>
        <small className="copyright">© 2018 Relic Entertainment</small>
      </div>
    );
  }
}

ArticleModal.propTypes = {
  article: PropTypes.shape({
    articleType: PropTypes.string,
    title: PropTypes.string,
    slug: PropTypes.string.isRequired,
    authorPath: PropTypes.string,
    publishedOn: PropTypes.string,
    introduction: PropTypes.string,
    bannerPath: PropTypes.string,
    body: PropTypes.string,
  }),
  articleSummaries: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string,
  })),
  content: PropTypes.object,
};

themeable(ArticleModal, {
  forwards: [
    ArticleBody,
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/News/ArticleModal.jsx